import { UcademySdk } from '@sdk';

export const sdk = new UcademySdk(import.meta.env['VITE_API_URL']);
